import "./Notifications.scss";
import React from "react";
import NotificationStore from "../uidispatcherapi/NotificationStore";
import type { Notification } from "../uidispatcherapi/NotificationStore";
const styleByNotificationType = {
	"server-error": "error",
	"user-error": "warning",
	warning: "warning",
	info: "info",
	success: "success",
};

const DEFAULT_NOTIFICATIONS_TIMEOUT_MS = 10000;
function InfoBox({ notification }: { notification: Notification }) {
	const [isDismissed, setIsDismissed] = React.useState(false);
	const bsStyle = styleByNotificationType[notification.type] ?? "info";

	const dismiss = () => {
		setIsDismissed(true);
		setTimeout(() => {
			NotificationStore.dismiss(notification);
		}, 1000);
	};

	setTimeout(dismiss, notification.timeout ?? DEFAULT_NOTIFICATIONS_TIMEOUT_MS);

	return (
		<div className={`react-toast-notification test-notification ${isDismissed ? "unmount" : ""}`}>
			<div
				className={`react-toast-notifications__toast react-toast-notifications__toast--${bsStyle}`}
				data-selenium={`notification-${notification.id}`}>
				<div className="react-toast-notifications__toast__icon-wrapper" />
				<div className="react-toast-notifications__toast__content test-notification-text">
					{notification.text}
				</div>
				{(notification.dismissable ?? !notification.timeout) && (
					<div
						role="button"
						className="react-toast-notifications__toast__dismiss-button"
						data-testid="test-notification-close"
						onClick={dismiss}
					/>
				)}
			</div>
		</div>
	);
}

export class Notifications extends React.Component<
	Record<PropertyKey, never>,
	{
		notifications: ReadonlyArray<Notification>;
	}
> {
	_unsubscribe: () => void;

	constructor(props) {
		super(props);
		this.state = this._getStateFromStore();
		this._unsubscribe = NotificationStore.listen(this.handleNotificationUpdate.bind(this));
	}

	componentWillUnmount() {
		if (typeof this._unsubscribe === "function") {
			this._unsubscribe();
		}
	}

	handleNotificationUpdate: (...args: Array<any>) => any = () => {
		this.setState(this._getStateFromStore());
	};

	_getStateFromStore() {
		return {
			notifications: NotificationStore.get() || [],
		};
	}

	render() {
		const flyoutNotifications = this.state.notifications.map(notification => (
			<InfoBox notification={notification} key={notification.uuid} />
		));

		if (flyoutNotifications.length === 0) {
			return null;
		}

		return <div className="test-notifications react-toast-notifications__container">{flyoutNotifications}</div>;
	}
}
